import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import iconSprite from '../../../assets/icon-sprite.svg';

class FundWalletInit extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { visible, onClose = function $() {} } = this.props;
    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="linkDetailsLabel">Fund wallet</h5>
            <button type="button" className="close" onClick={onClose}>
              <svg width="48" height="48">
                <use xlinkHref={iconSprite + '#close-icon'}></use>
              </svg>
            </button>
          </div>
          <div className="modal-body">
            <p className="modal-body__p">
              Enter your card details to fund your wallet.
            </p>
            <form action="" className="modal-form">
              <div className="form-group">
                <label htmlFor="cardNumber" className="form-label">Card Number</label>
                <input type="number" className="form-control" id="cardNumber" />
                <div className="form-text error-message">
                  <p>Card Number is required.</p>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label htmlFor="expiryDate" className="form-label">Card Expiry</label>
                    <input type="number" className="form-control" id="expiryDate" />
                    <div className="form-text error-message">
                      <p>Expiry date is required.</p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label htmlFor="cvv" className="form-label">CVV</label>
                    <input type="number" className="form-control" id="cvv" />
                    <div className="form-text error-message">
                      <p>CVV is required.</p>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#enterAmount">Add card</button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default FundWalletInit;
